import AcUnit from '@material-ui/icons/AcUnit';

import List from './List';

export default {
  list: List,
  icon: AcUnit,
};
